import React from "react";

const Footer = () => {
    return (
        <div className="row justify-content-between align-items-center mt-4 fixed-bottom" style={{ backgroundColor:"white" }}>
            {/*<div className="col-md-5">*/}
            {/*    <p class="m-0 text-black-50 small bold">Copyright ©  2023 Track Mate All rights reserved.</p>*/}
            {/*</div>*/}
            <div className="col-md-12 text-end">
                <p className="m-0 text-black-50 small mb-2 m-2 footertext">Designed and Develop by<a className="text-black-50 bold footertext" href="https://www.sagarinfotech.com/" target="_blank" style={{ fontWeight: "bold",}}>Sagar Infotect PVT LTD.</a></p>
            </div>
        </div>
    );
}

export default Footer;
